export const ROSTER_BASE_PATH = '/roster-management';

/**
 * Roster's sub-routes are keyed 1:1 with their URL segment (`/roster-management/roster`,
 * `/roster-management/onboarding`, ...), so the nav can derive both the active item and
 * its navigation target from the URL rather than listing every route.
 */
export const rosterPathSegment = (pathname: string): string | undefined =>
  pathname.startsWith(ROSTER_BASE_PATH)
    ? pathname.slice(ROSTER_BASE_PATH.length).split('/').filter(Boolean)[0]
    : undefined;

export const rosterNavKeyForPathname = (pathname: string): string | undefined =>
  pathname.startsWith(ROSTER_BASE_PATH)
    ? rosterPathSegment(pathname) ?? 'roster'
    : undefined;

export const rosterNavTargetForKey = (key: string): string =>
  `${ROSTER_BASE_PATH}/${key}`;
